import api from './client';

export interface ResearchInput {
  product: string;
  intent: string;
  ideas: string;
  targetAudience?: string | undefined;
  budget?: 'small' | 'medium' | 'large' | undefined;
  industry?: string | undefined;
}

export interface MarketingPlan {
  audienceProfile: {
    primaryPersona: string;
    painPoints: string[];
    psychographics: string;
    bestTimeToCall: string;
  };
  messagingStrategy: {
    coreMessage: string;
    hook: string;
    valueProps: string[];
    objectionHandling: Record<string, string>;
    toneAndStyle: string;
  };
  callScript: {
    opening: string;
    body: string;
    cta: string;
    objectionResponses: Record<string, string>;
    closing: string;
    fullScript: string;
  };
  campaignStructure: {
    recommendedContacts: string;
    callTiming: string;
    followUpCadence: string;
    sequenceSteps: string[];
  };
  expectedOutcomes: {
    estimatedAnswerRate: string;
    estimatedConversionRate: string;
    tipToImprove: string;
  };
  competitorIntel?: {
    topCompetitors: string[];
    theirMessaging: string;
    differentiator: string;
  };
}

export interface IntentTemplate {
  id: string;
  label: string;
  icon: string;
  description: string;
  exampleIdeas: string;
}

export interface SavedPlan {
  id: string;
  product: string;
  intent: string;
  ideas: string | null;
  target_audience: string | null;
  industry: string | null;
  plan: MarketingPlan;
  created_at: string;
  updated_at: string;
}

export async function generateResearch(input: ResearchInput) {
  const { data } = await api.post<{ planId: string; plan: MarketingPlan; script: string }>(
    '/api/v1/planner/research',
    input
  );
  return data;
}

export async function getPlans(page = 1, limit = 20) {
  const { data } = await api.get<{
    plans: SavedPlan[];
    pagination: { page: number; limit: number; total: number; pages: number };
  }>('/api/v1/planner/plans', { params: { page, limit } });
  return data;
}

export async function getPlan(id: string) {
  const { data } = await api.get<{ plan: SavedPlan }>(`/api/v1/planner/plans/${id}`);
  return data;
}

export async function createCampaignFromPlan(planId: string) {
  const { data } = await api.post(`/api/v1/planner/plans/${planId}/create-campaign`);
  return data;
}

export async function getIntentTemplates() {
  const { data } = await api.get<{ templates: IntentTemplate[] }>('/api/v1/planner/intent-templates');
  return data.templates;
}
